'use strict';
var parent = require('../es/parse-int');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/parse-int.js
// module id = Qi9W
// module chunks = 15